$(function() {

    $.practitioner = {};

    $.practitioner.delayFadeOut = ($("#practitioner-container").next('section').hasClass('profile-section')) ? false : true;

    $.practitioner.lastProfile = false;

    // durations

    $.practitioner.duration = '75%';

    $.practitioner.calculatePinDuration = function() {
        var contentHeight = $('#practitioner-container .content-container').outerHeight();
        if ($.practitioner.lastProfile) {
            $.practitioner.pinDuration = 0;
        } else {
            $.practitioner.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.practitioner.pinDuration;
	};

    $.practitioner.zoomDuration = '100%';

    $.practitioner.endDuration = ($.practitioner.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.practitioner.tl = {};

    // in

	$.practitioner.tl.in = new TimelineMax();

    $.practitioner.tl.in.addLabel("start");

    $.practitioner.tl.in.set("#practitioner-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.practitioner.tl.in.from("#practitioner-svg .line-1", 1, { x:"2560" }, "start");
        $.practitioner.tl.in.from("#practitioner-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.practitioner.tl.in.from("#practitioner-svg .line-3", 1, { x:"2560", delay: 0.5 }, "start");
        $.practitioner.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#practitioner-in', triggerHook: 'onEnter', duration: $.practitioner.duration })
        	.setTween($.practitioner.tl.in)
        	// .addIndicators({name: 'practitioner in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#practitioner-pin', triggerHook: 'onLeave', duration: $.practitioner.calculatePinDuration })
        .setPin('#practitioner-container .svg-background')
        // .addIndicators({name: 'practitioner pin'})
        .addTo($.controller);

    // zoom

    $.practitioner.zoom = {};

    $.practitioner.tl.zoom = new TimelineMax();

    $.practitioner.tl.zoom.addLabel("start");
    $.practitioner.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.practitioner.tl.zoom.to("#practitioner-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.practitioner.zoom.scale = 10;
        $.practitioner.zoom.offset = $.practitioner.zoom.scale * 100 / 2;
        $.practitioner.zoom.xy = "-"+ $.practitioner.zoom.offset +"%";

        $.practitioner.tl.zoom.to("#practitioner-svg .svg-text", 2, { x:$.practitioner.zoom.xy, y:$.practitioner.zoom.xy, scaleX:$.practitioner.zoom.scale, scaleY:$.practitioner.zoom.scale, force3D:true }, "start");

    }

    $.practitioner.tl.zoom.to("#practitioner-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.practitioner.tl.zoom.to("#practitioner-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.practitioner.tl.zoom.fromTo("#practitioner-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.practitioner.tl.zoom.set("#practitioner-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.practitioner.tl.zoom.set("#practitioner-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.practitioner.tl.zoom.fromTo("#practitioner-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.practitioner.tl.zoom.fromTo("#practitioner-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.practitioner.tl.zoom.fromTo("#practitioner-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.practitioner.tl.zoom.fromTo("#practitioner-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#practitioner-zoom', triggerHook: 'onCenter', duration: $.practitioner.zoomDuration })
        .on('start', function () {
            $.practitioner.tl.in.seek($.practitioner.tl.in.duration(), false);
        })
        .setTween($.practitioner.tl.zoom)
        // .addIndicators({name: 'practitioner zoom'})
        .addTo($.controller);

    $.practitioner.tl.out = new TimelineMax();

    $.practitioner.tl.out.addLabel("start");

    $.practitioner.tl.out.to("#practitioner-container .content-container", 1, { opacity:0 }, "start");

    if ($.practitioner.delayFadeOut) {
        $.practitioner.tl.out.to("#practitioner-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.practitioner.tl.out.to("#practitioner-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#practitioner-end', triggerHook: 'onCenter', duration: $.practitioner.endDuration })
        .setTween($.practitioner.tl.out)
        // .addIndicators({name: 'practitioner out'})
        .addTo($.controller);

});
